import React, {useEffect, useState} from 'react'
import '../styles/marketValueSummaryV1.scss'
import PrintIcon from '../../../assets/icons/print-icon'
import VDI_Car from '../../../assets/icons/vdi_car'
import VDI_Drive from '../../../assets/icons/vdi_drive'
import VDI_Engine from '../../../assets/icons/vdi_engine'
import VDI_Color from '../../../assets/icons/vdi_color'
import VDI_Type from '../../../assets/icons/vdi_type'
import VDI_Interior from '../../../assets/icons/vdi_interior'
import PriceTagIcon from '../../../assets/icons/price-tag-icon'
import DollarSignIcon from '../../../assets/icons/dollar-sign-icon'
import CircleCheckIcon from '../../../assets/icons/circle-check-icon'
import MarketValueSummaryV1Loader from './marketValueSummaryV1Loader'


const decimalFormatter = new Intl.NumberFormat('en-US', { style: 'decimal' })

function MarketValueSummaryV1({appraisalInfo}){
    const renderRelevanceLabel = (score) =>{
      if(score>=80){
        return "Best"
      }
      else if(score>=50){
        return "Better"
      }
      else{
        return "Good"
      }
    }
  
    const getMinMaxMSRPPercentage = (comparables) =>{
       return comparables.reduce(
        (acc, { msrp_percentage }) => ({
          min: Math.min(acc.min, msrp_percentage),
          max: Math.max(acc.max, msrp_percentage),
        }),
        { min: Infinity, max: -Infinity }
      );
    }
    const renderPriceDifference = () =>{
      if(appraisalInfo.vehicle.price_difference){
        if(appraisalInfo.vehicle.price_difference.position==="above_market" || appraisalInfo.vehicle.price_difference.position==="at_market"){
          return(
            <div className="appraisal-page-value-details-breakdown-item appraisal-page-value-details-breakdown-item-price-difference appraisal-page-value-details-breakdown-item-price-difference-above">
              <div className="appraisal-page-value-details-breakdown-item-icon">
                <DollarSignIcon/>
              </div>
              <div className="appraisal-page-value-details-breakdown-item-label">
                Priced within&nbsp;<span>{`$${decimalFormatter.format(appraisalInfo.vehicle.price_difference.amount)}`}</span>&nbsp;of Market Value
              </div>
            </div>
          )
        }
        else if(appraisalInfo.vehicle.price_difference.position==="at_market"){
          return(
            <div className="appraisal-page-value-details-breakdown-item appraisal-page-value-details-breakdown-item-price-difference appraisal-page-value-details-breakdown-item-price-difference-at">
              <div className="appraisal-page-value-details-breakdown-item-icon">
                <DollarSignIcon/>
              </div>
              <div className="appraisal-page-value-details-breakdown-item-label">
                Priced within&nbsp;<span>{`$${decimalFormatter.format(appraisalInfo.vehicle.price_difference.amount)}`}</span>&nbsp;of Market Value
              </div>
            </div>
          )
        }
        else{
          return(
            <div className="appraisal-page-value-details-breakdown-item appraisal-page-value-details-breakdown-item-price-difference appraisal-page-value-details-breakdown-item-price-difference-below">
              <div className="appraisal-page-value-details-breakdown-item-icon">
                <DollarSignIcon/>
              </div>
              <div className="appraisal-page-value-details-breakdown-item-label">
                You Save vs Value
              </div>
              <div className="appraisal-page-value-details-breakdown-item-content">
                <h1>{`$${decimalFormatter.format(appraisalInfo.vehicle.price_difference.amount)}`}</h1>
              </div>
            </div>
          )
        }
      }
      else{
        return(<React.Fragment/>)
      }
    }
    if(appraisalInfo){
      let minMaxMSRPPercentage = null
      if(appraisalInfo.comparables && appraisalInfo.comparables.length){
        minMaxMSRPPercentage = getMinMaxMSRPPercentage(appraisalInfo.comparables)
      }
      return(
        <div className="appraisal-page-container">
          <div className="appraisal-page">
            <div className="appraisal-page-section appraisal-page-section-vehicle-details">
  
              <div className="appraisal-page-section-header">
                <div className="appraisal-page-section-header-title">
                  Vehicle Details
                </div>
              </div>
              <div className="appraisal-page-section-content">
                <div className="appraisal-page-vehicle-details">
                  <div className="appraisal-page-vehicle-details-thumbnail">
                    {appraisalInfo.vehicle.vehicle_photo?
                      <img src={appraisalInfo.vehicle.vehicle_photo}/>
                      :
                      "N/A"
                    }
                  </div>
                  <div className="appraisal-page-vehicle-details-breakdown">
                    <div className="appraisal-page-vehicle-details-breakdown-item">
                      <div className="appraisal-page-vehicle-details-breakdown-item-icon">
                        <VDI_Car/>
                      </div>
                      <div className="appraisal-page-vehicle-details-breakdown-item-text">
                        <h1>Trim</h1>
                        {appraisalInfo.vehicle.trim?appraisalInfo.vehicle.trim:"N/A"}
                      </div>
                    </div>
  
                    <div className="appraisal-page-vehicle-details-breakdown-item">
                      <div className="appraisal-page-vehicle-details-breakdown-item-icon">
                        <VDI_Engine/>
                      </div>
                      <div className="appraisal-page-vehicle-details-breakdown-item-text">
                        <h1>Engine</h1>
                        {appraisalInfo.vehicle.engine?appraisalInfo.vehicle.engine:"N/A"}
                      </div>
                    </div>
  
                    <div className="appraisal-page-vehicle-details-breakdown-item">
                      <div className="appraisal-page-vehicle-details-breakdown-item-icon">
                        <VDI_Color/>
                      </div>
                      <div className="appraisal-page-vehicle-details-breakdown-item-text">
                        <h1>Exterior</h1>
                        {appraisalInfo.vehicle.exterior_color?appraisalInfo.vehicle.exterior_color:"N/A"}
                      </div>
                    </div>
  
                    <div className="appraisal-page-vehicle-details-breakdown-item">
                      <div className="appraisal-page-vehicle-details-breakdown-item-icon">
                        <VDI_Interior/>
                      </div>
                      <div className="appraisal-page-vehicle-details-breakdown-item-text">
                        <h1>Interior</h1>
                        {appraisalInfo.vehicle.interior?appraisalInfo.vehicle.interior:"N/A"}
                      </div>
                    </div>
  
                    <div className="appraisal-page-vehicle-details-breakdown-item">
                      <div className="appraisal-page-vehicle-details-breakdown-item-icon">
                        <VDI_Drive/>
                      </div>
                      <div className="appraisal-page-vehicle-details-breakdown-item-text">
                        <h1>Drivetrain</h1>
                        {appraisalInfo.vehicle.drive_train?appraisalInfo.vehicle.drive_train:"N/A"}
                      </div>
                    </div>
  
                    <div className="appraisal-page-vehicle-details-breakdown-item">
                      <div className="appraisal-page-vehicle-details-breakdown-item-icon">
                        <VDI_Type/>
                      </div>
                      <div className="appraisal-page-vehicle-details-breakdown-item-text">
                        <h1>VIN</h1>
                        {appraisalInfo.vehicle.vin?appraisalInfo.vehicle.vin:"N/A"}
                      </div>
                    </div>
  
                  </div>
                </div>
              </div>
  
            </div>
            <div className="appraisal-page-section appraisal-page-section-value-details">
              <div className="appraisal-page-section-header">
                <div className="appraisal-page-section-header-title">
                  Value Details
                </div>
                <div className="appraisal-page-section-header-button hide-on-print" onClick={()=>{window.print()}}>
                  Print
                  <PrintIcon/>
                </div>
              </div>
              <div className="appraisal-page-section-content">
                <div className="appraisal-page-value-details-vehicle-info hide-on-print">
                  <span>{`${appraisalInfo.vehicle.year} ${appraisalInfo.vehicle.make} ${appraisalInfo.vehicle.model}`}</span>
                  <br/>
                  <span>VIN:</span> {appraisalInfo.vehicle.vin}
                </div>
                <div className="appraisal-page-value-details">
  
  
                  <div className="appraisal-page-value-details-graph-vehicle-info">
                    <div className="appraisal-page-value-details-graph-container">
                      <div className="appraisal-page-value-details-graph"></div>
                      <div className="appraisal-page-value-details-graph-overlay">
                        <div className="appraisal-page-value-details-graph-arrow" />
                        <div className="appraisal-page-value-details-graph-market-price">
                          <div className="appraisal-page-value-details-graph-market-price-average">
                            {`$${decimalFormatter.format(appraisalInfo.vehicle.ipacket_retail_value_average)}`}
                          </div>
                          <div className="appraisal-page-value-details-graph-market-price-sub-heading">
                            {`Market Value*`}
                            <br />
                            {`as of ${new Date(/*appraisalInfo.created_at*/).toLocaleDateString("en-US")}`}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
  
  
  
  
  
                  <div className="appraisal-page-value-details-breakdown">
                    {
                      appraisalInfo.vehicle.has_reconditioning_data?
                      <div className="appraisal-page-value-details-breakdown-item appraisal-page-value-details-breakdown-item-recon">
                        <div className="appraisal-page-value-details-breakdown-item-icon">
                          <CircleCheckIcon/>
                        </div>
                        <div className="appraisal-page-value-details-breakdown-item-label">
                          Vehicle Reconditioning
                        </div>
                        <div className="appraisal-page-value-details-breakdown-item-content">
                          <h1>Verified Complete</h1>
                        </div>
                      </div>
                      :
                      <React.Fragment/>
                    }
                    {appraisalInfo.vehicle.msrp?
                      <div className="appraisal-page-value-details-breakdown-item appraisal-page-value-details-breakdown-item-msrp">
                        <div className="appraisal-page-value-details-breakdown-item-icon">
                          <PriceTagIcon/>
                        </div>
                        <div className="appraisal-page-value-details-breakdown-item-label">
                          Original MSRP
                        </div>
                        <div className="appraisal-page-value-details-breakdown-item-content">
                          <h1>{`$${decimalFormatter.format(appraisalInfo.vehicle.msrp)}`}</h1>
                        </div>
                      </div>
                      :
                      <React.Fragment/>
                    }
  
                    <div className="appraisal-page-value-details-breakdown-item appraisal-page-value-details-breakdown-item-market">
                      <div className="appraisal-page-value-details-breakdown-item-icon">
                        <DollarSignIcon/>
                      </div>
                      <div className="appraisal-page-value-details-breakdown-item-label">
                        Market Value*
                      </div>
                      <div className="appraisal-page-value-details-breakdown-item-content">
                        <h1>{`$${decimalFormatter.format(appraisalInfo.vehicle.ipacket_retail_value_average)}`}</h1>
                        {appraisalInfo.vehicle.msrp?`${Math.round((appraisalInfo.vehicle.ipacket_retail_value_average/appraisalInfo.vehicle.msrp)*100)}% of MSRP`:<React.Fragment/>}
                      </div>
                    </div>
                    <div className="appraisal-page-value-details-breakdown-item appraisal-page-value-details-breakdown-item-dealer">
                      <div className="appraisal-page-value-details-breakdown-item-icon">
                        <PriceTagIcon/>
                      </div>
                      <div className="appraisal-page-value-details-breakdown-item-label">
                        Dealer Price
                      </div>
                      <div className="appraisal-page-value-details-breakdown-item-content">
                        <h1>{`$${decimalFormatter.format(appraisalInfo.vehicle.dealer_retail_value)}`}</h1>
                        {appraisalInfo.vehicle.msrp?`${Math.round((appraisalInfo.vehicle.dealer_retail_value/appraisalInfo.vehicle.msrp)*100)}% of MSRP`:<React.Fragment/>}
                      </div>
                    </div>
                    {renderPriceDifference(appraisalInfo.vehicle.price_difference)}
                  </div>
                </div>
              </div>
            </div>
            {
              appraisalInfo.comparables && appraisalInfo.comparables.length?
                appraisalInfo.vehicle.msrp?
                    <div className="appraisal-page-section appraisal-page-section-comparables">
                      <div className="appraisal-page-section-header">
                        <div className="appraisal-page-section-header-title">
                          {`Comparable ${appraisalInfo.vehicle.condition} ${appraisalInfo.vehicle.year} ${appraisalInfo.vehicle.make} ${appraisalInfo.vehicle.model} Vehicles Nearby`}
                        </div>
                      </div>
                      <div className="appraisal-page-section-content">
                        <div className="appraisal-page-comps-list">
                          <div className="appraisal-page-comps-list-tag">
                            This vehicle is priced at <span>{`${Math.round((appraisalInfo.vehicle.dealer_retail_value/appraisalInfo.vehicle.msrp)*100)}% of its original MSRP,`}</span> while similar vehicles range from <span>{`${Math.round(minMaxMSRPPercentage.min)}–${Math.round(minMaxMSRPPercentage.max)}%.`}</span>
                          </div>
                          <div className="appraisal-page-comps-list-highlight">
                          </div>
                          <div className="appraisal-page-comps-list-item appraisal-page-comps-list-header">
                            <div className="appraisal-page-comps-list-item-field">
                              Odometer
                            </div>
                            <div className="appraisal-page-comps-list-item-field">
                              MSRP
                            </div>
                            <div className="appraisal-page-comps-list-item-field">
                              Retail Price
                            </div>
                            <div className="appraisal-page-comps-list-item-field">
                              % MSRP
                            </div>
                          </div>
                          <div className="appraisal-page-comps-list-item appraisal-page-comps-list-item-current">
                            <div className="appraisal-page-comps-list-item-field">
                              {`${decimalFormatter.format(appraisalInfo.vehicle.mileage)} mi`}
                            </div>
                            <div className="appraisal-page-comps-list-item-field">
                              {`$${decimalFormatter.format(appraisalInfo.vehicle.msrp)}`}
                            </div>
                            <div className="appraisal-page-comps-list-item-field">
                              {`$${decimalFormatter.format(appraisalInfo.vehicle.dealer_retail_value)}`}
                            </div>
                            <div className="appraisal-page-comps-list-item-field">
                              {`${Math.round((appraisalInfo.vehicle.dealer_retail_value/appraisalInfo.vehicle.msrp)*100)}% of MSRP`}
                            </div>
                          </div>
                          {appraisalInfo.comparables.map(comp=>{
                            return(
                              <div className="appraisal-page-comps-list-item">
                                <div className="appraisal-page-comps-list-item-field">
                                  {`${decimalFormatter.format(comp.odometer)} mi`}
                                </div>
                                <div className="appraisal-page-comps-list-item-field">
                                  {`$${decimalFormatter.format(comp.msrp)}`}
                                </div>
                                <div className="appraisal-page-comps-list-item-field">
                                  {`$${decimalFormatter.format(comp.retail_price)}`}
                                </div>
                                <div className="appraisal-page-comps-list-item-field">
                                  {`${Math.round(comp.msrp_percentage)}% of MSRP`}
                                </div>
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    </div>
                  :
                    <div className="appraisal-page-section appraisal-page-section-comparables appraisal-page-section-comparables-no-msrp">
                      <div className="appraisal-page-section-header">
                        <div className="appraisal-page-section-header-title">
                          {`Comparable Vehicles Nearby`}
                        </div>
                      </div>
                      <div className="appraisal-page-section-content">
                        <div className="appraisal-page-comps-list">
                          <div className="appraisal-page-comps-list-item appraisal-page-comps-list-header">
                            <div className="appraisal-page-comps-list-item-field">
                              Vehicle
                            </div>
                            <div className="appraisal-page-comps-list-item-field">
                              Odometer
                            </div>
                            <div className="appraisal-page-comps-list-item-field">
                              Retail Price
                            </div>
                          </div>
                          <div className="appraisal-page-comps-list-item appraisal-page-comps-list-item-current">
                            <div className="appraisal-page-comps-list-item-field">
                              {`${appraisalInfo.vehicle.year} ${appraisalInfo.vehicle.make} ${appraisalInfo.vehicle.model}`}
                            </div>
                            <div className="appraisal-page-comps-list-item-field">
                              {`${decimalFormatter.format(appraisalInfo.vehicle.mileage)} mi`}
                            </div>
                            <div className="appraisal-page-comps-list-item-field">
                              {`$${decimalFormatter.format(appraisalInfo.vehicle.dealer_retail_value)}`}
                            </div>
                          </div>
                          {appraisalInfo.comparables.map(comp=>{
                            return(
                              <div className="appraisal-page-comps-list-item">
                                <div className="appraisal-page-comps-list-item-field">
                                  {`${comp.year} ${comp.make} ${comp.model}`}
                                </div>
                                <div className="appraisal-page-comps-list-item-field">
                                  {`${decimalFormatter.format(comp.odometer)} mi`}
                                </div>
                                <div className="appraisal-page-comps-list-item-field">
                                  {`$${decimalFormatter.format(comp.retail_price)}`}
                                </div>
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    </div>
              :
              <React.Fragment/>
            }
  
  
            <div className="appraisal-page-section appraisal-page-disclaimer">
              <div className="appraisal-page-section-content">
                *Disclaimer: The pricing information contained in this packet is provided for general reference only. All listed prices are estimates and approximations based on available market data at the time of publication. These values should not be relied upon as precise or guaranteed figures for the purposes of vehicle appraisals, financing, insurance, resale, or trade-in decisions. Actual market value may vary based on individual vehicle condition, location, and other market dynamics.
              </div>
            </div>
          </div>
        </div>
      )
    }
    return <MarketValueSummaryV1Loader />
  }

  export default MarketValueSummaryV1;